export default __webpack_public_path__ + "static/media/desktop-active.f7b3f383.svg";